"use client";

import { DynamicDocumentInstructions } from "@/configuration/document-mappings/types";
import {
  DocumentInstructionsCardView,
  InstructionsStateCard,
} from "@/src/components/tasks/document-management-instructions";
import { useBuildInstructions } from "@/src/components/tasks/use-processed-instructions";
import type { StepOutputs } from "@/src/lib/workflows/steps/step-outputs";
import { Section } from "@/src/models/section";
import { Task } from "@/src/models/task";

export function StridecareDocumentInstructions({
  task,
  section,
  mapping,
  stepOutputs,
  ccDescription,
}: {
  task: Task;
  section: Section;
  mapping: DynamicDocumentInstructions;
  stepOutputs: StepOutputs;
  ccDescription: string | null;
}) {
  const data = useBuildInstructions(task, section, mapping, stepOutputs, ccDescription);

  if (!data) {
    return <InstructionsStateCard message="No instructions found." />;
  }

  return <DocumentInstructionsCardView data={data} />;
}
